/**
 * Created by Jerker Nord on 2018-08-17.
 */
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {ITextStyles} from "./ITextStyles";

export class IceIceYetiMobileTextStyles implements ITextStyles {

    private static _instance:IceIceYetiMobileTextStyles = new IceIceYetiMobileTextStyles();

    static get instance():IceIceYetiMobileTextStyles {
        return this._instance;
    }

    constructor() {
        if(IceIceYetiMobileTextStyles._instance) {
            throw new Error("Error: IceIceYetiMobileTextStyles.constructor() - Instantiation failed: Use IceIceYetiMobileTextStyles.instance instead of new.");
        }
    }

    WIN_COUNTUP_NUMBERS_TEXT_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "yetiCountUp",
            size : 180
        }
    };
}